/**
 * Screen 6 - What are your challenges?
 */
import classnames from 'classnames';
import React, { PropTypes } from 'react';
import ButtonNext from './ButtonNext';
import ButtonPrevious from './ButtonPrevious';

function Challenges({
  nextStep,
  paragraphData,
  previousStep,
  resultStatedChallenge,
  setResult,
  stateOfReadiness,
}) {
  const {
    fieldActionExampleChallenge,
    fieldContemplationExampleChal,
    fieldMaintenanceExampleChalle,
    fieldPreparationExampleChalle,
    fieldText,
    fieldTitle,
  } = paragraphData;
  const updateChallenge = (evt) => {
    const newChallenge = evt.target.value;
    setResult({ resultStatedChallenge: newChallenge });
  };
  let exampleChallenge;
  if (stateOfReadiness === 'contemplation') {
    exampleChallenge = fieldContemplationExampleChal;
  } else if (stateOfReadiness === 'action') {
    exampleChallenge = fieldActionExampleChallenge;
  } else if (stateOfReadiness === 'maintenance') {
    exampleChallenge = fieldMaintenanceExampleChalle;
  } else if (stateOfReadiness === 'preparation') {
    exampleChallenge = fieldPreparationExampleChalle;
  } else {
    exampleChallenge = [{ value: '' }];
  }
  return (
    <div
      className={classnames({
        'goal--step-six': true,
      })}
    >
      <h4
        dangerouslySetInnerHTML={{
          __html: fieldTitle[0] ? fieldTitle[0].value : '',
        }}
      />
      <div
        className="description"
        dangerouslySetInnerHTML={{
          __html: fieldText[0].value,
        }}
      />
      <h5>
        Type your challenges
      </h5>
      <div>
        <textarea
          defaultValue={resultStatedChallenge}
          onChange={updateChallenge}
          placeholder={exampleChallenge[0].value}
        />
      </div>
      <ButtonPrevious
        previousStep={previousStep}
      />
      <ButtonNext
        disabled={!resultStatedChallenge}
        nextStep={nextStep}
      />
      <div
        style={{
          fontSize: '16px',
          color: '#aaa',
        }}
      >
        Step 6 of 10
      </div>
    </div>
  );
}

Challenges.propTypes = {
  nextStep: PropTypes.func,
  paragraphData: PropTypes.shape({}),
  previousStep: PropTypes.func,
  resultStatedChallenge: PropTypes.string,
  setResult: PropTypes.func,
  stateOfReadiness: PropTypes.string,
};

export default Challenges;



// WEBPACK FOOTER //
// js/src/goals/Challenges.js